<script context="module">

  export const DEFAULT_BANNER = { imageURL: '/app/imd/content/banner-default.svg' };

  export async function preloadBanners (imdBanners = []) {
    const banners_loaded = await imdBanners.reduce(async (acc, banner) => {
      try {
        banner.objectURL = await createBannerObjectURL(banner);
        return [...(await acc), banner];
      } catch (e) {
        console.warn(e);
        return acc;
      }
    }, []);

    if (!banners_loaded.length) return [DEFAULT_BANNER];
    return banners_loaded;
  }

  async function createBannerObjectURL ({ imageURL }) {

    const response = await fetch(imageURL);
    if (!response.ok) {
      throw new Error(`Fetch failed (${response.status}) for "${imageURL}"`);
    }
    const blob = await response.blob();
    // Not sure why objectURL is used but it creates a memory leak as these are
    // never revoked.
    return URL.createObjectURL(blob);
  }
</script>

<script>

  import { playerOn, banners as banners_store } from 'apps/imd/stores';
  import { onDestroy } from 'svelte';
  import Deferred from '~/deferred';
  import InfoSnippets from './InfoSnippets.svelte';

  export let loading = new Deferred();

  let timeout_loop, interval_update;

  let banners = [DEFAULT_BANNER];
  let currentIndex = 0;
  let currentUrl;
  let imageURL;

  export function getBanners () {
    return loading.promise;
  }

  async function update (banners_update) {
    if (!banners_update) return;

    banners = await preloadBanners(banners_update);
    currentIndex = banners.length - 1;
    nextIndex();
    loading.resolve(banners);
  }

  interval_update = setInterval(async () => {
    console.log('Update banners…');
    const banners_prev = banners;
    loading = new Deferred();
    await update();
    // Clean up old resources
    banners_prev.forEach(({ objectURL }) => {
      if (objectURL) URL.revokeObjectURL(objectURL);
    });
  }, 1000 * 60 * 60);

  $: if (banners) {
    const banner = banners[currentIndex];
    currentUrl = banner.objectURL || banner.imageURL;
    imageURL = banner.imageURL;
  }

  function nextIndex () {

    // Keep same banner while Player is running
    if ($playerOn) return continueLoop();

    const next = currentIndex + 1;
    // Loop finished
    if (next == banners.length) {
      // Filter
      const today = new Date();
      banners = banners.filter(banner => new Date(banner.end) >= today);
      if (!banners.length) banners = [DEFAULT_BANNER];
      currentIndex = 0;
    }
    else {
      currentIndex = next;
    }
    continueLoop();
  }


  const unsubscribe = [
    banners_store.subscribe(value => {
      update(value);
    })
  ];

  function continueLoop () {
    clearTimeout(timeout_loop);
    if (banners.length > 1) {
      timeout_loop = setTimeout(nextIndex, 10000);
    }
  }

  onDestroy(() => {
    console.log('unsubscribe', unsubscribe);
    unsubscribe.forEach(x => x());
    clearTimeout(timeout_loop);
    clearInterval(interval_update);
  });

</script>

<img class="banner" src={currentUrl} data-url={imageURL} alt="Banner" />
<InfoSnippets/>

<style>
  .banner {
    height: 537px;
    object-fit: contain;
  }
</style>
